angular.module('unergie.main')
.controller('createSmsModalCtrl', ($scope, $uibModalInstance, ApiUser, idAccount, phone, ReferencesService, PrmUtilsService, AlertManager, AuthService, ErrorCatcher) => {
    $scope.phone = phone

    $scope.sms = {
        text: '\n\nPlüm énergie',
    }

    $scope.sendSms = function () {
        $scope.sending = true
        return ApiUser.sendSms({ id_account: idAccount }, { message: $scope.sms.text }).$promise.then(() => {
            AlertManager.success('SMS envoyé avec succès')
            return $scope.ok() }).catch(ErrorCatcher)
        .finally(() => ($scope.sending = false))
    }

    // RETURN OK
    $scope.ok = () => $uibModalInstance.close()

    $scope.close = () => $uibModalInstance.dismiss()
})
